import Empty from 'app/components/UI-Elements/Feedback/Empty'
import useTranslation from 'app/lib/hooks/useTranslation'
import React from 'react'

type Props = {
  recordType?: string
  id?: string
  extra?: React.ReactNode
}
const KEmpty: React.FC<Props> = ({ recordType = 'default', id = 'description' }) => {
  const { tCore } = useTranslation({ scope: 'empty', recordType })

  return <Empty description={tCore({ id })} />
}

export default KEmpty
